export const loginEventsConfig = {
    parentSelector: '.customer.custom-login.login',
    events: {
        // Login field focus events
        loginFieldFocus: {
            selector: '#customer_login input[type="email"], #customer_login input[type="password"]',
            event: {
                event: 'login',
                element: 'text_field',
                action: 'focus',
                trigger: 'focus',
                getDynamicData: (element) => {
                    const fieldType = element.type === 'email' ? 'Email' : 'Password';
                    return {
                        field: fieldType
                    };
                }
            }
        },

        // Login field input events
        loginFieldInput: {
            selector: '#customer_login input[type="email"], #customer_login input[type="password"]',
            event: {
                event: 'login',
                element: 'text_field',
                action: 'input',
                trigger: 'input',
                getDynamicData: (element) => {
                    const fieldType = element.type === 'email' ? 'Email' : 'Password';
                    return {
                        field: fieldType,
                        field_value: element.value
                    };
                }
            }
        },

        // Login link click events
        loginLinks: {
            selector: '.login--link-wrapper a[href*="recover"], .login--link-wrapper a[href*="login"], .login--link-wrapper a[href*="zakelijk-account"]',
            event: {
                event: 'login',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_text: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },

        // Login button click
        loginButton: {
            selector: '#customer_login button.button--primary',
            event: {
                event: 'login',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    click_text: element.textContent.trim()
                })
            }
        },

        // // Login submit valid/invalid
        // loginSubmit: {
        //     selector: 'form',
        //     event: {
        //         event: 'login',
        //         component: '',
        //         element: 'login',
        //         action: 'submit',
        //         trigger: 'submit',
        //         getDynamicData: (element) => {
        //             const isValid = element.checkValidity();
        //             return {
        //                 action_value: isValid ? 'valid' : 'invalid'
        //             };
        //         }
        //     }
        // },

        // Recovery field focus
        recoveryFieldFocus: {
            selector: 'form[action="/account/recover"] #RecoverEmail',
            event: {
                event: 'recovery',
                element: 'text_field',
                action: 'focus',
                trigger: 'focus',
                getDynamicData: (element) => ({
                    field: element.id
                })
            }
        },

        // Recovery field input
        recoveryFieldInput: {
            selector: 'form[action="/account/recover"] #RecoverEmail',
            event: {
                event: 'recovery',
                element: 'text_field',
                action: 'input',
                trigger: 'input',
                getDynamicData: (element) => ({
                    field: element.id,
                    field_value: element.value
                })
            }
        },

        // Recovery form submit
        recoverySubmit: {
            selector: 'form[action="/account/recover"]',
            event: {
                event: 'recovery',
                component: '',
                element: 'recovery',
                action: 'submit',
                trigger: 'submit',
                getDynamicData: (element) => ({
                    action_value: 'submit'
                })
            }
        },

        // Login field error events
        loginFieldError: {
            selector: '#customer_login #CustomerEmail, #customer_login #CustomerPassword, form[action="/account/recover"] #RecoverEmail',
            event: {
                event: 'login',
                component: '',
                element: 'text_field',
                action: 'error',
                trigger: 'blur',
                getDynamicData: (element) => {
                    // Check if the field has an error (is invalid and has been touched)
                    const isInvalid = !element.validity.valid && (element.classList.contains('is-invalid') || element.classList.contains('touched'));
                    
                    // Only proceed if the field is invalid and has a validation message
                    if (!isInvalid || !element.validationMessage) {
                        return null; // Return null to prevent event from being pushed
                    }
                    
                    const fieldType = element.id === 'CustomerEmail' || element.id === 'RecoverEmail' ? 'Email' : 'Password';
                    return {
                        field: fieldType,
                        error_message: element.validationMessage || 'This field is required'
                    };
                }
            }
        }
    }
}; 